function mesurezVous($lang)
{
	var lang = $lang;
	var error = 0;

	var field1 = document.getElementById("field1").value; //epaule
	var field2 = document.getElementById("field2").value; //taille
	var field3 = document.getElementById("field3").value; //ventre
	var field4 = document.getElementById("field4").value; //hanches
	var field5 = document.getElementById("field5").value; //ossature

	if(field1 == "" || isNaN(field1))
		error = 1;

	else if(field2 == "" || isNaN(field2))
		error = 1;

	else if(field3 == "" || isNaN(field3))
		error = 1;

	else if(field4 == "" || isNaN(field4))
		error = 1;

	if(error == 0)
	{
		//jQuery(".resultatFigure").slideUp("fast");
		//jQuery("div.silhouette").slideUp("fast");

		if(document.getElementById("fieldUnit1").innerHTML == "pouces")
		{
			field1 = field1 * 2.54;
			field2 = field2 * 2.54;
			field3 = field3 * 2.54;
			field4 = field4 * 2.54;
		}

		field1 = parseInt(field1);
		field2 = parseInt(field2);
		field3 = parseInt(field3);
		field4 = parseInt(field4);

		if(field1 > field4) // V
		{
			if (lang == 'fr') {
				window.location.href = "/pages/votre-silhouette-est-silhouette-v/";
			} else {
				window.location.href = "/pages/your-silhouette-is-silhouette-v/";				
			}
		}
		else if(field1 == field4 && Math.abs(field4-field2) < 25 && field5 == "3") // I
		{
			if (lang =='fr') {
				window.location.href = "/pages/votre-silhouette-est-silhouette-i/";
			} else {
				window.location.href = "/pages/your-silhouette-is-silhouette-i/";				
			}
		}
		else if(field4 > field1) // A
		{
			if (lang == 'fr') {
				window.location.href = "/pages/votre-silhouette-est-silhouette-a/";
			} else {
				window.location.href = "/pages/your-silhouette-is-silhouette-a/";				
			}
		}
		else if(field1 == field4 && field4-field2 >= 25) // X
		{
			if (lang == 'fr') {
				window.location.href = "/pages/votre-silhouette-est-silhouette-x/";
			} else {
				window.location.href = "/pages/your-silhouette-is-silhouette-x/";				
			}
		}

		else if(field1 == field4 && Math.abs(field4-field2) < 25 && (field5 == "1" || field5 == "2")) // H
		{
			if (lang == 'fr') {
				window.location.href = "/pages/votre-silhouette-est-silhouette-h/";
			} else {
				window.location.href = "/pages/your-silhouette-is-silhouette-h/";				
			}
		}
		else // O
		{
			if (lang == 'fr') {
				window.location.href = "/pages/votre-silhouette-est-silhouette-o/";
			} else {
				window.location.href = "/pages/your-silhouette-is-silhouette-o/";				
			}
		}
	}
	else
	alert("Toutes les mesures doivent être des nombres.");
}

function changeUnit(unit)
{
	document.getElementById("fieldUnit1").innerHTML = unit;
	document.getElementById("fieldUnit2").innerHTML = unit;
	document.getElementById("fieldUnit3").innerHTML = unit;
	document.getElementById("fieldUnit4").innerHTML = unit;
}

function vosCouleurs()
{
	var field1;
	var field2;
	var field3;
	var field4;
	var field5;
	var field6;	

	var tfield1 = 0;
	var tfield2 = 0;
	var tfield3 = 0;
	var tfield4 = 0;
	var tfield5 = 0;
	var tfield6 = 0;	

	for (index=0; index < document.getElementsByName('q1').length; index++) {
		if (document.getElementsByName('q1')[index].checked) {
			field1 = document.getElementsByName('q1')[index].value;
			break;
		}
	}	

	for (index=0; index < document.getElementsByName('q2').length; index++) {
		if (document.getElementsByName('q2')[index].checked) {
			field2 = document.getElementsByName('q2')[index].value;
			break;
		}
	}	

	for (index=0; index < document.getElementsByName('q3').length; index++) {
		if (document.getElementsByName('q3')[index].checked) {
			field3 = document.getElementsByName('q3')[index].value;
			break;
		}
	}	

	for (index=0; index < document.getElementsByName('q4').length; index++) {
		if (document.getElementsByName('q4')[index].checked) {
			field4 = document.getElementsByName('q4')[index].value;
			break;
		}
	}	

	for (index=0; index < document.getElementsByName('q5').length; index++) {
		if (document.getElementsByName('q5')[index].checked) {
			field5 = document.getElementsByName('q5')[index].value;
			break;
		}
	}	

	for (index=0; index < document.getElementsByName('q6').length; index++) {
		if (document.getElementsByName('q6')[index].checked) {
			field6 = document.getElementsByName('q6')[index].value;
			break;
		}
	}	

	if (field1 == '1')
		tfield1++;
	if (field2 == '1')
		tfield1++;
	if (field3 == '1')
		tfield1++;
	if (field4 == '1')
		tfield1++
	if (field5 == '1') {
		tfield1++;
		tfield3++;
	}

	if (field6 == '1') {
		tfield1++;
		tfield3++;
	}	

	if (field1 == '2')
		tfield2++;
	if (field2 == '2')
		tfield2++;
	if (field3 == '2')
		tfield2++;
	if (field4 == '2')
		tfield2++
	if (field5 == '2') {
		tfield2++;
		tfield4++;
	}

	if (field6 == '2') {
		tfield2++;
		tfield4++;
	}	

	if (field1 == '3')
		tfield3++;
	if (field2 == '3')
		tfield3++;
	if (field3 == '3')
		tfield3++;
	if (field4 == '3')
		tfield3++	

	if (field1 == '4')
		tfield4++;
	if (field2 == '4')
		tfield4++;
	if (field3 == '4')
		tfield4++;
	if (field4 == '4')
		tfield4++	

	if(tfield1 >= tfield2 && tfield1 >= tfield3 && tfield1 >= tfield4)
	{		
      //jQuery("#resultatHiver").slideDown("fast");
      document.getElementById("resultatHiver").style.display = "block";
	}

	else if(tfield2 >= tfield1 && tfield2 >= tfield3 && tfield2 >= tfield4)
	{
      //jQuery("#resultatPrintemps").slideDown("fast");
      document.getElementById("resultatPrintemps").style.display = "block";
	}

	else if(tfield3 >= tfield1 && tfield3 >= tfield2 && tfield3 >= tfield4)
	{
      //jQuery("#resultatEte").slideDown("fast");
      document.getElementById("resultatEte").style.display = "block";
	}

	else if(tfield4 >= tfield1 && tfield4 >= tfield2 && tfield4 >= tfield3)
	{
      //jQuery("#resultatAutomne").slideDown("fast");
      document.getElementById("resultatAutomne").style.display = "block";
	}
}

/*function infolettre()
{

	pass = true;

	if(document.getElementById("field1").value == "")
		pass = false;
	else if(document.getElementById("field2").value == "")
		pass = false;
	else if(document.getElementById("field3").value == "")
		pass = false;
	else if(document.getElementById("field4").value == "")
		pass = false;
	else if(document.getElementById("field5").value == "")
		pass = false;
	else if(document.getElementById("field6").value == "")
		pass = false;
	else if(document.getElementById("field7").value == "")
		pass = false;	

	else if(document.getElementById("field3").value != document.getElementById("field4").value)
		pass = false;	

	if(pass)
		document.oi_form.submit();
	else
		alert("Tous les champs sont obligatoires.");
}*/



/*jQuery(document).ready(function($){

	// Change le texte du module tweet à l'accueil
	$('.twitter-time').html('> Voir ce tweet');

	// Redimensionne les images pour avoir une hauteur uniforme dans le carrousel
	var hauteursArray = [];
	$('.carousel-inner').children('.item').children('img').each(function(){
		hauteursArray.push(this.height);		
	});

	var minHauteur = Math.min.apply(Math, hauteursArray);
	if (minHauteur > 480) {
		$('.carousel-inner .item img').css('height', '480');
	} else {
		$('.carousel-inner .item img').css('height', minHauteur);
	}
	$('.carousel-inner .item img').css('width', 'auto');
});*/

// POPUP INFOLETTRE
/*jQuery(document).ready(function( $ ) {
	window.setTimeout(function() {
		if (Cookies.get('popup_infolettre') != '1') {
			$.magnificPopup.open({
				items: {
					src: '#popup_infolettre',
					type: 'inline'
				},
			});
			Cookies.set('popup_infolettre', '1', { expires: 60 });
		}
	},3000)
});*/